export function storageUrl(relativePath?: string | null): string | null {
  if (!relativePath) return null;

  const base = import.meta.env.VITE_STORAGE_HOST ?? '';
  if (!relativePath.startsWith('/')) {
    relativePath = '/' + relativePath;
  }
  return `${base}${relativePath}`;
}
